import axiosInstance from "@/api/axiosInstance";
import { ValidateCheckoutAvailabilityResponse } from "./types";

export const validateCheckoutAvailability = async (
  eventCheckoutSessionUuid: string,
): Promise<ValidateCheckoutAvailabilityResponse> => {
  const response =
    await axiosInstance.post<ValidateCheckoutAvailabilityResponse>(
      `/api/private/event-checkout-sessions/${eventCheckoutSessionUuid}/validate-availability`,
    );

  return response.data;
};
